import $ from "jquery";

// Make Acquiror type and Acquiror country fields optonal or required depending on if Pending box is ticked
const makeAcquirorFieldsRequiredOrOptional = () => {
  const acquirorType = "wd_transaction_form_new_acquiror_type";
  const $acquirors = $("section#acquirors");
  const $typeLabel = $acquirors.find(`label[for='${acquirorType}']`);
  const $typeSelect = $acquirors.find(`select#${acquirorType}`);
  const $typeFormGroup = $typeSelect.parent();
  const $countryLabel = $acquirors.find("label[for*='country_id']");
  const $countrySelect = $acquirors.find("select[name*='[country_id]']");
  const $countryFormGroup = $countrySelect.parent();

  const classRequiredToOptional = element => $(element).removeClass("required").addClass("optional");
  const classOptionalToRequired = element => $(element).removeClass("optional").addClass("required");

  if ($("#wd_transaction_form_pending").is(":checked")) {
    classRequiredToOptional($typeFormGroup);
    classRequiredToOptional($typeLabel);
    $typeLabel.find("abbr").detach();
    $typeSelect.prop("required", false)
               .attr("aria-required", false);
    classRequiredToOptional($typeSelect);

    classRequiredToOptional($countryFormGroup);
    classRequiredToOptional($countryLabel);
    $countryLabel.find("abbr").detach();
    $countrySelect.prop("required", false)
                  .attr("aria-required", false);
    classRequiredToOptional($typeSelect);

  } else {
    const requiredAbbr = "<abbr title='required'>*</abbr>";
    classOptionalToRequired($typeFormGroup);
    classOptionalToRequired($typeLabel);
    $typeLabel.prepend(requiredAbbr);
    $typeSelect.prop("required", true)
               .attr("aria-required", true);
    classOptionalToRequired($typeSelect);

    classOptionalToRequired($countryFormGroup);
    classOptionalToRequired($countryLabel);
    $countryLabel.prepend(requiredAbbr);
    $countrySelect.prop("required", true)
                  .attr("aria-required", true);
    classOptionalToRequired($typeSelect);
  }
};

// Make Acquiror type and Acquiror country fields optonal or required when Pending box is ticked
$(document).on("change", "#wd_transaction_form_pending", function() {
  makeAcquirorFieldsRequiredOrOptional();
});

// Check if Pending box is ticked when adding a new Acquiror and on page load
$(document).on("cocoon:after-insert ready turbolinks:load", function() {
  if ($("#wd_transaction_form_pending").is(":checked")) {
    makeAcquirorFieldsRequiredOrOptional();
  }
});
